import PropTypes from 'prop-types';

import { RateBrowserRatePropType } from './rate-browser-rate';

/** @typedef {import('./rate-browser-rate').RateBrowserRatePropType} RateBrowserRatePropType */

export const RateBrowserProviderPropType = PropTypes.shape({
  labelProviderId: PropTypes.string,
  sellerLabelProviderId: PropTypes.string,
  rates: PropTypes.arrayOf(RateBrowserRatePropType),
  errorMessage: PropTypes.string,
  // the properties below this line are added by the front end.
  isLoading: PropTypes.bool,
  name: PropTypes.string,
});

/**
 * @typedef {object} RateBrowserProviderPropType
 * @property {string} labelProviderId
 * @property {string} sellerLabelProviderId
 * @property {RateBrowserRatePropType[]} rates
 * @property {string} errorMessage
 * @property {boolean} isLoading added by the front end
 * @property {string} name added by the front end
 */
